import { render, staticRenderFns } from "./AutocompleteSingle.vue?vue&type=template&id=5a353636"
import script from "./AutocompleteSingle.vue?vue&type=script&lang=js"
export * from "./AutocompleteSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports